import {
  getAgentIds,
  getEntityLabel,
  modifyFilter,
  singularListingType,
  updateOfficeSelect,
  getCorrectOffSalesRegion,
} from "../shared/util";
import Helmet from "react-helmet";
import Pagination from "../search/pagination";
import PropTypes from "prop-types";
import React, { Component } from "react";
import request from "superagent";
import ResultView from "./result-view";
import SalesRentals from "../my-listings/sales-rentals";
import ListingsMap from "./sold-map/";
import { getTitleBase, parsePage } from "../shared/util";
import { USER_MANAGER } from "../../constants/constants";
import _ from "lodash";

import "./solds.scss";
class Solds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        activePage: parsePage(props),
        agentId: getAgentIds(props.entity),
        agentSelect: true,
        listingType: singularListingType(props.params.listingType),
        resultsPerPage: 15,
        sortField:
          props.entity.siteOptions.selectSoldsPage.sortField === "price"
            ? "soldPrice"
            : props.entity.siteOptions.selectSoldsPage.sortField,
        sortDirection: "desc",
      },
      endCount: 0,
      mapListings: [],
      rentalsCount: 0,
      results: [],
      resultCount: 0,
      salesCount: 0,
      startCount: 0,
    };
  }

  componentDidMount() {
    this.setState(
      {
        filter: updateOfficeSelect(
          this.state.filter,
          this.props.entity.agentType,
          this.props.entity
        ),
      },
      () => {
        this.getCounts();
        this.getMapListings();
      }
    );
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.abort();
    }
    if (this.countRequest) {
      this.countRequest.abort();
    }
    if (this.mapListingsRequest) {
      this.mapListingsRequest.abort();
    }
  }

  fetchSolds = () => {
    this.request = this.fetch("/api/solds", this.state.filter, (results) => {
      this.setState(results);
    });
  };

  //update api for below filter
  getCounts = () => {
    let filter = {
      agentId: getAgentIds(this.props.entity),
      agentSelect: true,
    };
    filter = updateOfficeSelect(
      filter,
      this.props.entity.agentType,
      this.props.entity
    );
    this.countRequest = this.fetch("/api/solds/counts", filter, (results) => {
      this.setState(results);
      if (results.salesCount === 0) {
        this.changeFilter("listingType", "rental");
      } else {
        this.fetchSolds();
      }
    });
  };

  getMapListings = () => {
    let filter = {
      ...this.state.filter,
      resultsPerPage: 500,
      listingType: this.state.filter.listingType,
      listingFields: {
        regionUrlPart: 1,
        showMap: 1,
        showPrice: 1,
        displayPrice: 1,
        price: 1,
        ourListing: 1,
        listingType: 1,
        identifier: 1,
        location: 1,
      },
    };

    this.mapListingsRequest = this.fetch("/api/solds", filter, (results) => {
      this.setState({ mapListings: results.results });
    });
  };

  fetch = (url, filter, cb) => {
    return request
      .post(url)
      .set("Content-Type", "application/json")
      .send(filter)
      .end((error, response) => {
        if (response && response.body) {
          cb(response.body);
        } else {
          console.error(error);
        }
      });
  };

  changeFilter = (name, value) => {
    const filter = modifyFilter(this.state.filter, name, value);
    this.setState({ filter: filter }, () => {
      this.fetchSolds();
      this.getMapListings();
    });
  };

  render() {
    let map = null;
    if (
      (this.state.filter.listingType === "sale" ||
        this.state.filter.listingType === "rental") &&
      this.state.mapListings.length > 0
    ) {
      map = (
        <ListingsMap
          listings={this.state.mapListings}
          showMap={this.props.entity.siteOptions.selectSoldsPage.showMap}
          googleMapsKey={this.props.config ? this.props.config.gm : null}
        />
      );
    }
    const title = `Select ${
      this.props.params.listingType === "sales" ? "Solds" : "Select Rentals"
    } - ${getTitleBase(this.props.entity)}`;
    return (
      <div className="web-container container featured-listings sold-listings">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`${
              this.props.params.listingType === "sales"
                ? "Solds"
                : "Select Rentals"
            } from ${this.props.entity.brand} ${getEntityLabel(
              this.props.entity
            ).toLowerCase()} ${
              this.props.entity.displayName
            } in ${getCorrectOffSalesRegion(this.props.entity)}.`}
          />
        </Helmet>
        <div className="page-header">
          <h1>
            {this.props.entity.agentType === USER_MANAGER
              ? "Office Select Solds"
              : "Select Solds"}
          </h1>
          <div className="header-separator"></div>
        </div>
        <SalesRentals
          changeFilter={this.changeFilter}
          resultState={this.state}
        />
        {map}
        <ResultView listings={this.state.results} filter={this.state.filter} />
        <div className="results-footer">
          <Pagination
            count={this.state.resultCount}
            pageSize={this.state.filter.resultsPerPage}
            activePage={this.state.filter.activePage}
            location={this.props.location}
            changeFilter={this.changeFilter}
          />
        </div>
      </div>
    );
  }
}

Solds.propTypes = {
  entity: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};

export default Solds;



// WEBPACK FOOTER //
// ./src/components/solds/solds.js